import { render } from "./DefaultHeader.vue?vue&type=template&id=5c0d974a"
import script from "./DefaultHeader.vue?vue&type=script&lang=js"
export * from "./DefaultHeader.vue?vue&type=script&lang=js"
script.render = render

export default script